var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExploreEmptyState(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 119,
    height: 125,
    viewBox: "0 0 119 125",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M104.36 46.3338C106.472 46.3338 108.184 44.6199 108.184 42.5057C108.184 40.3916 106.472 38.6777 104.36 38.6777C102.247 38.6777 100.535 40.3916 100.535 42.5057C100.535 44.6199 102.247 46.3338 104.36 46.3338Z",
    fill: "#EAEEF9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.76618 67.0349C4.15582 67.0349 5.28235 65.9074 5.28235 64.5165C5.28235 63.1256 4.15582 61.998 2.76618 61.998C1.37653 61.998 0.25 63.1256 0.25 64.5165C0.25 65.9074 1.37653 67.0349 2.76618 67.0349Z",
    fill: "#EAEEF9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3326 112.312C15.7222 112.312 16.8488 111.185 16.8488 109.794C16.8488 108.403 15.7222 107.275 14.3326 107.275C12.9429 107.275 11.8164 108.403 11.8164 109.794C11.8164 111.185 12.9429 112.312 14.3326 112.312Z",
    fill: "#EAEEF9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7812 112.312L63.0902 101.248V55.8867L27.7812 66.8654V112.312Z",
    fill: "#F1F3F9",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M98.3988 112.312L63.0898 101.248V55.8867L98.3988 66.8654V112.312Z",
    fill: "#F1F3F9",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0902 123.461L27.7812 112.397V67.0352L63.0902 78.099V123.461Z",
    fill: "white",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0898 123.461L98.3988 112.397V67.0352L63.0898 78.099V123.461Z",
    fill: "white",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0898 55.8865L46.4887 43.4609L10.5898 55.546L27.7809 66.8652L63.0898 55.8865Z",
    fill: "#F1F3F9",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0898 55.8865L79.691 43.4609L115.59 55.546L98.3988 66.8652L63.0898 55.8865Z",
    fill: "#F1F3F9",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7809 67.0352L63.0898 78.099L45.4775 89.333L10.5898 77.7586L27.7809 67.0352Z",
    fill: "#F1F3F9",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M98.3988 67.0352L63.0898 78.099L80.7022 89.333L115.59 77.7586L98.3988 67.0352Z",
    fill: "#F1F3F9",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M72.9413 12.3375C77.8879 25.7619 79.3623 28.7447 79.8462 41.9727C79.6602 44.9921 79.5448 48.2755 78.1212 50.9194C76.2201 54.9638 71.57 57.7648 67.1767 57.8102C62.6508 57.8911 58.2137 55.1199 56.2165 50.8468C54.8114 48.2535 54.8561 44.7062 56.7835 42.3517C58.8788 40.0935 62.5651 39.5305 65.2167 40.9415C68.1336 42.2814 69.8746 45.0676 70.5195 48.0059C71.1644 50.9443 70.881 54.1312 70.0939 57.0289C68.4476 64.0763 67.0841 64.4173 63.0468 76.349",
    stroke: "#C9D4E2",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeDasharray: "4 4"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M78.9647 5.233C78.9532 7.20698 77.1162 8.41567 74.7867 7.78538C72.3339 7.36727 70.598 6.93635 70.4862 5.17455C70.5425 3.36775 72.5138 2.6606 74.8211 1.86346C77.5877 0.764135 78.8082 3.30402 78.9647 5.233Z",
    fill: "#F1F3F9",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1159 11.2679C64.3589 12.5475 66.9797 12.9207 68.2568 10.9661C69.6571 8.79928 70.8557 7.22404 69.5679 5.77723C68.3249 4.49759 67.1152 5.35911 64.3486 6.45843C62.1308 7.58994 61.6601 9.86609 63.1159 11.2679Z",
    fill: "#F1F3F9",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M68.8511 3.10282C69.9823 2.62066 71.3375 2.97439 71.9422 3.88748C72.1997 4.17684 72.5021 4.63339 72.5916 4.96775C73.5545 7.21828 73.2518 9.44943 71.9525 9.97659C70.53 10.7159 68.5701 9.4491 67.8201 7.32076C67.641 6.65203 67.5514 6.31767 67.4171 5.81613C67.2716 4.60087 67.7198 3.58498 68.8511 3.10282C69.0191 3.05782 68.8511 3.10282 68.8511 3.10282Z",
    fill: "#F1F3F9"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M68.8511 3.10282C69.9823 2.62066 71.3375 2.97439 71.9422 3.88748C72.1997 4.17684 72.5021 4.63339 72.5916 4.96775C73.5545 7.21828 73.2518 9.44943 71.9525 9.97659C70.53 10.7159 68.5701 9.4491 67.8201 7.32076C67.641 6.65203 67.5514 6.31767 67.4171 5.81613C67.2716 4.60087 67.7198 3.58498 68.8511 3.10282ZM68.8511 3.10282C68.8511 3.10282 69.0191 3.05782 68.8511 3.10282Z",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8471 39.3307H14.6571V37.1406H12.7799V39.3307H10.5898V41.2704H12.7799V43.4605H14.6571V41.2704H16.8471V39.3307Z",
    fill: "#AAB2C5"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6596 94.2779H19.4696V92.0879H17.5924V94.2779H15.4023V96.2177H17.5924V98.4077H19.4696V96.2177H21.6596V94.2779Z",
    fill: "#AAB2C5"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M117.397 94.4023L114.717 93.0494L116.07 90.3699L113.773 89.2103L112.42 91.8898L109.741 90.537L108.543 92.9103L111.222 94.2632L109.869 96.9427L112.166 98.1023L113.519 95.4228L116.198 96.7756L117.397 94.4023Z",
    fill: "#AAB2C5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExploreEmptyState);
export default __webpack_public_path__ + "static/media/explore-empty-state.7993ee76e8f830369aa4ba2a746cc961.svg";
export { ForwardRef as ReactComponent };